import { GetSpeechSynthesisTaskCommand, InvalidNextTokenException, PollyClient, StartSpeechSynthesisTaskCommand, SynthesizeSpeechCommand } from "@aws-sdk/client-polly";
import {SSMLSplit} from "ssml-split";

const splitter = new SSMLSplit({
  synthesizer: "aws",
  breakParagraphsAboveHardLimit: true,
  extraSplitChars: ".;?!",
})

export default class TtsClient {
  /**
   * @param {{
   *  credentialProviderUrl?: string,
   *  credentials?: object,
   *  outputBucket?: string
   * }} options
   */
  constructor(options) {
    /** @type{string} */
    this.credentialProviderUrl = options.credentialProviderUrl || "/rest/v1/tts_credentials"
    this.credentials = options.credentials
    this.outputBucket = options.outputBucket
  }

  /**
   * 
   * @param {string} text 
   * @returns Promise
   */
  async synthesizeSpeech(text, speed) {
    if (!this.credentials) {
      let resp = await fetch(this.credentialProviderUrl, { method: "POST" }).then((resp) => resp.json());
      this.credentials = {
        accessKeyId: resp.access_key_id,
        secretAccessKey: resp.secret_access_key,
        sessionToken: resp.session_token,
        region: "us-east-1"
      }

      if (!this.outputBucket) {
        this.outputBucket = resp.output_bucket
      }
    }

    let client = new PollyClient({
      credentials: this.credentials,
      region: "us-east-1"
    });


    let batches = splitter.split(text);

    let promises = batches.map((batch) => {
      let wrappedText = batch.replace("<speak>", `<speak><prosody rate="${speed}">`).replace("</speak>", "</prosody></speak>");
      let params = {
        Text: wrappedText,
        OutputFormat: "mp3",
        TextType: "ssml",
        VoiceId: "Joanna",
        SampleRate: "22050",
      }
      let audioProm = client.send(new SynthesizeSpeechCommand(params)).then(async (resp) => {
        if (!resp.AudioStream) throw ("Expected AudioStream to be defined");
        if (!(resp.AudioStream instanceof ReadableStream)) throw ("Expected a ReadableStream");
        let reader = resp.AudioStream.getReader();
        let chunks = [];
        return new Promise((resolve) => {
          reader.read().then(function process({ done, value }) {
            if (done) {
              resolve(chunks);
            } else {
              chunks.push(value)
              reader.read().then(process)
            }
          });
        })
      })

      let speechMarksProm = client.send(new SynthesizeSpeechCommand({...params, OutputFormat: "json", SpeechMarkTypes: ["word", "ssml"]})).then(async (resp) => {
        if (!resp.AudioStream) throw ("Expected AudioStream to be defined");
        if (!(resp.AudioStream instanceof ReadableStream)) throw ("Expected a ReadableStream");
        let reader = resp.AudioStream.getReader();
        let chunks = [];
        return new Promise((resolve) => {
          reader.read().then(function process({ done, value }) {
            if (done) {
              resolve(chunks);
            } else {
              let decoded = new TextDecoder().decode(value)
              decoded.split("\n").forEach((line) => {
                if(line !== "") {
                  chunks.push(JSON.parse(line))
                }
              })
              reader.read().then(process)
            }
          });
        })
      })

      return Promise.all([audioProm, speechMarksProm]);
    });

    let chunks = await Promise.all(promises);

    return chunks.map((chunk) => {
      let blob = new Blob(chunk[0], { type: "audio/mpeg" });
      let url = URL.createObjectURL(blob);
      return {url, marks: chunk[1]}
    })
  }
}